<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('用户注销.联系电话')" prop="mobile" >
        <a-input v-model="form.mobile" :placeholder="$t('通用.输入.请输入')+$t('用户注销.联系电话')" disabled/>
      </a-form-model-item>
      <a-form-model-item :label="$t('用户注销.注销原因')" prop="reason" >
        <a-input v-model="form.reason" :placeholder="$t('通用.输入.请输入')+$t('用户注销.注销原因')" disabled/>
      </a-form-model-item>
      <a-form-model-item :label="$t('用户注销.审核状态')" prop="status" >
        <a-select :placeholder="$t('通用.输入.请选择')+$t('用户注销.审核状态')" v-model="form.status">
<!--          <a-select-option v-for="(d, index) in statusOptions" :key="index" :value="parseInt(d.value)" >{{ d.label }}</a-select-option>-->
          <a-select-option :value="1">{{$t('用户注销.待审核')}}</a-select-option>
          <a-select-option :value="2">{{$t('用户注销.审核成功')}}</a-select-option>
          <a-select-option :value="3">{{$t('用户注销.审核失败')}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('用户注销.审核失败原因')" v-if="form.status===3" prop="failReason" >
        <a-input v-model="form.failReason" :placeholder="$t('通用.输入.请输入')+$t('用户注销.审核失败原因')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ formType === 1 ? $t('用户注销.保存') : $t('用户注销.修改') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('通用.按钮.取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCancel, addCancel, updateCancel } from '@/api/biz/cancel'

export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true
    }
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        mobile: null,
        reason: null,
        status: 0,
        failReason: null,
        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        // reason: [
        //   { required: true, message: '注销原因不能为空', trigger: 'blur' }
        // ],
        failReason: [
          { required: true, message: this.$t('用户注销.审核失败原因')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],

        status: [
          { required: true, message: this.$t('用户注销.审核状态')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        mobile: null,
        reason: null,
        status: 0,
        failReason: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.按钮.新增')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCancel({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.按钮.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCancel(this.form).then(response => {
              this.$message.success(
                this.$t('通用.文本.修改成功'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCancel(this.form).then(response => {
              this.$message.success(
                this.$t('通用.文本.新增成功'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
